import { useMemo } from "react";
import { HeaderMiniDropdown } from "../pages/mindSHARE";
import { MARKET_FAVORITES } from "../services/mindshareMarket";
import { twitchMarketGames, twitchMarketMetricLabel } from "../services/twitchMarket";
import MarketMindPanel from "./MarketMindPanel";

const favoriteOptions = MARKET_FAVORITES.filter(option => ["upcoming", "recent"].includes(option.value));

export default function TwitchMarketMind({ games, filtered, period, onPeriodChange, sortBy, onSortChange,
  shape, onShapeChange, favorites, onFavoritesChange, splitView, onSplitChange, hasActiveFilters, loading, onSelect, activeId }) {
  const rows = useMemo(() => twitchMarketGames(games, period, sortBy), [games, period, sortBy]);
  const selected = useMemo(() => twitchMarketGames(filtered, period, sortBy), [filtered, period, sortBy]);
  const metricLabel = twitchMarketMetricLabel(period, sortBy);
  const marketProps = useMemo(() => ({
    colorMode: "total", metricLabel, onSelect, activeId,
    renderDetails: ({ node }) => <div className="mm-platform-details ms-tooltip">
      {node.data.image && <img src={node.data.image} alt="" />}
      <strong>{node.data.name}</strong>
      <span>{Number(node.data.value).toLocaleString(undefined, { maximumFractionDigits: 1 })} {metricLabel}</span>
      <small>Click for streamers and game details</small>
    </div>,
  }), [metricLabel, onSelect, activeId]);
  return <MarketMindPanel label="Twitch Market Mind" rows={rows} filtered={selected}
    splitView={splitView} onSplitChange={onSplitChange} hasActiveFilters={hasActiveFilters}
    shape={shape} onShapeChange={onShapeChange} favorites={favorites} onFavoritesChange={onFavoritesChange}
    favoriteOptions={favoriteOptions} loading={loading} marketProps={marketProps}
    controls={<>
      <HeaderMiniDropdown prefix="Period:" value={period} onChange={onPeriodChange} active width={190}
        options={[{ value: "now", label: "Live" }, { value: "1d", label: "1 Day" }, { value: "7d", label: "7 Days" }]} />
      <HeaderMiniDropdown prefix="Sort By:" value={sortBy} onChange={onSortChange} active width={180}
        options={[{ value: "hours", label: twitchMarketMetricLabel(period, "hours") },
          { value: "peak", label: twitchMarketMetricLabel(period, "peak") }]} />
    </>} />;
}
